<h1 mat-dialog-title>
    {{ data.title}}
</h1>

<div mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="1vh" [formGroup]="form">
        <div fxFlex *ngIf="form.controls.title.value ">
            <span class="label">{{'Title' | translate}}:</span> {{form.controls.title.value }}
        </div>
        <!-- <div fxFlex *ngIf="form.controls.caseId.value">
            <span class="label">{{'Case ID' | translate}}:</span> {{form.controls.caseId.value }}
        </div> -->
        <div fxFlex *ngIf="form.controls.description.value">
            <span class="label">{{'Remarks' | translate}}:</span> {{form.controls.description.value}}
        </div>
        <!-- <div fxFlex *ngIf="form.controls.selectedType.value">
            <span class="label">{{'Link to Material' | translate}}: </span>
            <span class="document" (click)="openDocument()" *ngIf="form.controls.selectedType.value != 'camera'">
                <mat-icon [matTooltip]="form.controls.document.value"
                    *ngIf="form.controls.selectedType.value == 'audio'">audio_file</mat-icon>
                <mat-icon [matTooltip]="form.controls.document.value"
                    *ngIf="form.controls.selectedType.value == 'video'">play_circle_filled</mat-icon>
                <mat-icon [matTooltip]="form.controls.document.value"
                    *ngIf="form.controls.selectedType.value == 'image'">collections</mat-icon>
                <mat-icon [matTooltip]="form.controls.document.value"
                    *ngIf="form.controls.selectedType.value == 'file'">description</mat-icon>
            </span>
            <span *ngIf="form.controls.selectedType.value == 'camera'">{{form.controls.camera.value}}</span>
        </div> -->
        <!-- <div fxFlex *ngIf="form.controls.selectedType.value">
            <span class="label">{{'Link to Material' | translate}}: </span>
            <span class="document" (click)="openDocument()" *ngIf="form.controls.selectedType.value != 'camera'">
                <mat-icon [matTooltip]="form.controls.document.value"
                    *ngIf="form.controls.selectedType.value == 'audio'">audio_file</mat-icon>
                <mat-icon [matTooltip]="form.controls.document.value"
                    *ngIf="form.controls.selectedType.value == 'video'">play_circle_filled</mat-icon>
                <mat-icon [matTooltip]="form.controls.document.value"
                    *ngIf="form.controls.selectedType.value == 'image'">collections</mat-icon>
                <mat-icon [matTooltip]="form.controls.document.value"
                    *ngIf="form.controls.selectedType.value == 'file'">description</mat-icon>
            </span>
            <span *ngIf="form.controls.selectedType.value == 'camera'">{{form.controls.camera.value}}</span>
        </div> -->
        <div fxFlex *ngIf="data.note?.type === 'threat' && threatTypesDisplay">
            <span class="label">{{ metadata.get('threat_types')?.displayName || ('Incident Types' | translate) }}:</span>
            {{ threatTypesDisplay }}
        </div>
        <div fxFlex *ngIf="documentsList.length || camerasList.length">
            <span class="label">{{'Link to Materials' | translate}}: </span>
            <span class="document" (click)="openDocuments(documentsList, 'audio')"
                *ngIf="documentsList.length && hasItem(documentsList,'audio')"><mat-icon>audio_file</mat-icon>
            </span>
            <span class="document" (click)="openDocuments(documentsList, 'video')"
                *ngIf="documentsList.length && hasItem(documentsList,'video')"><mat-icon>play_circle_filled</mat-icon>
            </span>
            <span class="document" (click)="openDocuments(documentsList, 'image')"
                *ngIf="documentsList.length && hasItem(documentsList,'image')"><mat-icon>collections</mat-icon>
            </span>
            <span class="document" (click)="openDocuments(documentsList,'file')"
                *ngIf="documentsList.length && hasItem(documentsList,'file')"><mat-icon>description</mat-icon>
            </span>
            <span class="document" *ngIf="camerasList.length"
                (click)="opencameras(camerasList, data.note)"><mat-icon>videocam</mat-icon></span>
        </div>
        <div fxFlex *ngIf="form.controls.actionDate.value">
            <span class="label">{{'Entry Date/Occurrence Date' | translate}}:</span> {{form.controls.actionDate.value}}
        </div>
        <div fxFlex *ngIf="form.controls.actionTime.value">
            <span class="label">{{'Entry Time/Occurrence Time' | translate}}:</span> {{form.controls.actionTime.value}}
        </div>
        <ng-container *ngIf="form.controls.interest.value == 'person'">
            <div fxFlex *ngIf="form.controls.personOfInterestName.value">
                <span class="label">{{'Name or Designation' | translate}}:</span>
                {{form.controls.personOfInterestName.value}}
            </div>
            <div fxFlex *ngIf="form.controls.personOfInterestDOB.value">
                <span class="label">{{'DOB' | translate}}:</span>
                {{form.controls.personOfInterestDOB.value}}
            </div>
            <div fxFlex *ngIf="form.controls.personOfInterestApproximateAge.value">
                <span class="label">{{'Approximate age' | translate}}:</span>
                {{form.controls.personOfInterestApproximateAge.value}}
            </div>
            <div fxFlex *ngIf="form.controls.personOfInterestGender.value">
                <span class="label">{{'Gender' | translate}}:</span>
                {{form.controls.personOfInterestGender.value | enum: metadata.get('person_of_interest_gender').enum}}
            </div>
            <div fxFlex *ngIf="form.controls.personOfInterestGender.value === 'other' && form.controls.personOfInterestGenderOther.value">
                <span class="label">{{'Other gender' | translate}}:</span>
                {{form.controls.personOfInterestGenderOther.value}}
            </div>
            <div fxFlex *ngIf="form.controls.personOfInterestHairColor.value && metadata.get('person_of_interest_hair_color')">
                <span class="label">{{'Hair color' | translate}}:</span>
                {{form.controls.personOfInterestHairColor.value | enum: metadata.get('person_of_interest_hair_color').enum}}
            </div>
            <div fxFlex *ngIf="form.controls.personOfInterestHeight.value">
                <span class="label">{{'Height' | translate}}:</span>
                {{form.controls.personOfInterestHeight.value}}
            </div>
            <div fxFlex *ngIf="form.controls.personOfInterestWeight.value">
                <span class="label">{{'Weight' | translate}}:</span>
                {{form.controls.personOfInterestWeight.value}}
            </div>
            <div fxFlex *ngIf="form.controls.personOfInterestEyeColor.value && metadata.get('person_of_interest_eye_color')">
                <span class="label">{{'Eye color' | translate}}:</span>
                {{form.controls.personOfInterestEyeColor.value | enum: metadata.get('person_of_interest_eye_color').enum}}
            </div>
            <div fxFlex *ngIf="form.controls.personOfInterestRace.value && metadata.get('person_of_interest_race')">
                <span class="label">{{'Race' | translate}}:</span>
                {{form.controls.personOfInterestRace.value | enum: metadata.get('person_of_interest_race').enum}}
            </div>
            <div fxFlex *ngIf="form.controls.personOfInterestDistinguishingFeatures.value">
                <span class="label">{{'Distinguishing features' | translate}}:</span>
                {{form.controls.personOfInterestDistinguishingFeatures.value}}
            </div>
            <div fxFlex *ngIf="form.controls.personOfInterestDescription.value">
                <span class="label">{{'Profile' | translate}}:</span>
                {{form.controls.personOfInterestDescription.value}}
            </div>
        </ng-container>
        <ng-container *ngIf="form.controls.interest.value == 'car'">
            <div fxFlex *ngIf="form.controls.plateOfInterest.value">
                <span class="label">{{'Plate Number' | translate}}:</span> {{form.controls.plateOfInterest.value}}
            </div>
            <div fxFlex *ngIf="form.controls.plateOfInterestDescription.value">
                <span class="label">{{'Car Description' | translate}}:</span>
                {{form.controls.plateOfInterestDescription.value}}
            </div>
            <div fxFlex *ngIf="form.controls.plateOfInterestIdentifier.value">
                <span class="label">{{'Car Identifier' | translate}}:</span>
                {{form.controls.plateOfInterestIdentifier.value}}
            </div>
            <div fxFlex *ngIf="form.controls.carType.value">
                <span class="label">{{'Car Type' | translate}}:</span>
                {{form.controls.carType.value | enum: metadata.get('car_type').enum}}
            </div>
            <div fxFlex *ngIf="form.controls.carMake.value">
                <span class="label">{{'Car Make' | translate}}:</span> {{form.controls.carMake.value}}
            </div>
            <div fxFlex *ngIf="form.controls.carModel.value">
                <span class="label">{{'Car Model' | translate}}:</span> {{form.controls.carModel.value}}
            </div>
            <div fxFlex *ngIf="form.controls.carColor.value">
                <span class="label">{{'Car Color' | translate}}:</span> {{form.controls.carColor.value | enum:
                metadata.get('car_color').enum}}
            </div>
        </ng-container>
        <div fxFlex *ngIf="form.controls.notes.value">
            <span class="label">{{'Remarks' | translate}}:</span>
            {{form.controls.notes.value}}
        </div>
        <div fxFlex *ngIf="form.controls.investigators.value">
            <span class="label">{{'Investigators' | translate}}:</span> {{form.controls.investigators.value}}
        </div>
        <div fxFlex *ngIf="form.controls.investigatorGroups.value">
            <span class="label">{{'Investigator Groups' | translate}}:</span> {{form.controls.investigatorGroups.value}}
        </div>
        <div fxFlex *ngIf="form.controls.address.value">
            <span class="label">{{'Address' | translate}}:</span> {{form.controls.address.value }}
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <div fxLayout="row" fxFlex fxLayoutGap="0px">
        <!-- <div fxFlex *ngIf="data.note?.type === 'threat' && !data.isReadOnly && data.note?.threat && data.note?.threat?.threat_status != 'resolved'">
            <button class="green-text" mat-raised-button
                (click)="resolveThreat()">
                {{ "Resolve" | translate }}
            </button>
        </div> -->
        <div fxFlex align="right">
            <button class="green-text" mat-raised-button (click)="editNote(data.note)"
                *ngIf="data.note?.type != 'material' && data.note?.type != 'call' && data.note?.type != 'location' && !data.isReadOnly">
                {{ "Edit" | translate }}
            </button>
            <button mat-raised-button *ngIf="data.showTimelineBtn && data.caseId" (click)="goTimeline()">
                {{ "Timeline" | translate }}
            </button>
            <button class="red-text" mat-raised-button mat-dialog-close>
                {{ "Close" | translate }}
            </button>
        </div>
    </div>
</div>